/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
var Label_1 = require("./Label");
var ErrorMessage_1 = require("./ErrorMessage");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./SegmentedControl.css'); }
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-segmentedControl");
var SegmentedControl = /** @class */ (function (_super) {
    tslib_1.__extends(SegmentedControl, _super);
    function SegmentedControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SegmentedControl.prototype.render = function () {
        var _a = this.props, options = _a.options, value = _a.value, label = _a.label, vertical = _a.vertical, link = _a.link, onLinkClick = _a.onLinkClick, name = _a.name, hasWarning = _a.hasWarning, onChange = _a.onChange, errorMessage = _a.errorMessage;
        return (React.createElement("div", { className: classnames(moduleClassName(), !!vertical && moduleClassName("isVertical"), !!hasWarning && moduleClassName("hasWarning"), !!name && moduleClassName(name)) },
            !!label && (React.createElement(Label_1.Label, { label: label, link: link, onLinkClick: onLinkClick })),
            React.createElement("div", { className: classnames(moduleClassName("options")) }, options.map(function (option) { return (React.createElement("button", { key: option.value, role: "button", className: classnames(moduleClassName("option"), value === option.value && moduleClassName("option-isActive")), type: "button", name: option.name, onClick: function (e) { return onChange(e, option.value); }, "aria-pressed": value === option.value }, option.label)); })),
            !!errorMessage && React.createElement(ErrorMessage_1.ErrorMessage, null, errorMessage)));
    };
    SegmentedControl.propTypes = {
        label: PropTypes.node,
        value: PropTypes.any,
        name: PropTypes.string,
        link: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        errorMessage: PropTypes.string,
        hasWarning: PropTypes.bool,
        vertical: PropTypes.bool,
        onLinkClick: PropTypes.func,
        onChange: PropTypes.func.isRequired,
        options: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.node.isRequired,
            name: PropTypes.string,
            value: PropTypes.any.isRequired
        })).isRequired
    };
    return SegmentedControl;
}(React.Component));
exports.SegmentedControl = SegmentedControl;